// Owner: engagements. The screen loads with the route (plan §10.2); the URL is validated from the light
// `engagement-type-tabs` module.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { EngagementTypes } from '../../../features/engagements/admin/EngagementTypes';
import { ENGAGEMENT_TYPE_TABS } from '../../../features/engagements/admin/engagement-type-tabs';

// A tab or type that does not read as one is left out of the address (the screen opens on General).
const Search = z.object({
  type: z.string().optional().catch(undefined),
  tab: z.enum(ENGAGEMENT_TYPE_TABS).optional().catch(undefined),
});

export const Route = createFileRoute('/_settings/settings/engagement-types')({
  validateSearch: Search,
  component: EngagementTypesRoute,
});

function EngagementTypesRoute() {
  const { type, tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <EngagementTypes
      {...(type ? { selected: type } : {})}
      {...(tab ? { tab } : {})}
      onSelect={(next, nextTab) =>
        void navigate({
          search: {
            ...(next ? { type: next } : {}),
            ...(nextTab && nextTab !== 'general' ? { tab: nextTab } : {}),
          },
          replace: true,
        })
      }
    />
  );
}
